module.exports = __webpack_public_path__ + "static/media/score-three.f450742a.svg";